import React from 'react';
import { useSpring, animated } from 'react-spring';
import { useInView } from 'react-intersection-observer';

const RightFadeIn = ({ children }) => {
  const [ref, inView] = useInView();
  const fadeIn = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateX(0)' : 'translateX(100%)',
  });

  return (
    <animated.div ref={ref} style={fadeIn}>
      {children}
    </animated.div>
  );
};

export default RightFadeIn;
